import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../axiosInstance";

import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from "../components/Pagination";
import { useEffect, useState } from "react";
import { errorMessage } from "../hooks/UserLogs";
export default function PaymentMethod() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListPaymentMethods, setListPaymentMethods] = useState([]);
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [isLoading, setIsLoading] = useState(true)
  const [showError, setShowError] = useState(false);

  const bUrl = process.env.REACT_APP_B_URL;
  let header =
  {
    'Content-Type': 'application/json'
  };
  const navigate = useNavigate();

  const getListPaymentMethod = async (e) => {
    let ulr = "/paymentMode/find-all?page=" + currentPage + "&limit=10";

    const response = await axios.get(bUrl + ulr).catch((err) => {

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        seterrMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
      } else {
        let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '';
        seterrMsg(msg);
        setShowError(true);
      }

      setIsLoading(false)

    });

    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      } else {
        setListPaymentMethods(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
      }

      setIsLoading(false);

    }
  }

  const viewUpdate = () => {

  }

  const handleClose = () => {

  }

  const updatePaymentMethod = () => {

  }

  const handleCloseError = () => {
    setShowError(false);
  }

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  useEffect(() => {
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getListPaymentMethod();
  }, [currentPage])

  return (
    <div className="App">
      <div className="">


        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'>Clients</p></div>
                <div><Topbar /></div>
              </div>
              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <input type="email" onChange={(e) => getListPaymentMethod()} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="phone">Phone</label>
                    <input type="text" onChange={(e) => getListPaymentMethod()} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="code">Code</label>
                    <input type="text" onChange={(e) => getListPaymentMethod()} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                  </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">




                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">Id</th>
                          <th scope="col">Prénom</th>
                          <th scope="col">Deuxieme Nom</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Téléphone</th>
                          <th scope="col">Date</th>
                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListPaymentMethods.length > 0 ? ListPaymentMethods.map((a, i) => {
                          return <tr>
                            <td>{i}</td>
                            <td>{a.name}</td>
                            <td>{a.description}</td>
                            <td>{formatDate(a.createdDate)}</td>
                            <td>
                              <Link to={"/accountingOpByCustomer/" + a.fkIdAccounting}><i className='bx bx-folder-open' title="Opérations"></i></Link>
                              &nbsp;
                              <Link to={"/PaymentMethods/" + a.idCustomerWallet}><i className='bx bx-notepad' title="Détails"></i></Link>
                              &nbsp;
                              <i onClick={() => viewUpdate(a.idCustomerWallet, a.firstName, a.lastName, a.middleName, a.profile, a.address)} className='bx bx-edit-alt colore-icon' title="Update"></i>
                            </td>
                            {/* <td><Link to={"/collections/"+a.hashids+"/byAgent/"}>Dépots</Link></td> */}

                          </tr>
                        }) : <tr></tr>}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={handleClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Agency</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <form>

          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {isLoading ?
            <img src='../Custom.svg' width="30%" />
            :
            <Button variant="primary" onClick={updatePaymentMethod}>
              Modifier
            </Button>

          }
        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
